import { Container } from "react-bootstrap";
import allControls from "./controls.json";
import { Link } from "react-router-dom";

function Home() {
  return (
    <Container className="py-4">
      <p>
        The NIST 800-53 publication provides a list of security and privacy
        related controls for securing federal information systems. This website
        is intended to provide a convenient and easy to reference view of the
        5th revision of those controls.
      </p>
      <p>The 800-53 controls are divided into 20 control families:</p>
      <ul>
        {allControls.map((family) => {
          return (
            <li>
              <Link to={family.Family}>{family.Name}</Link>
            </li>
          );
        })}
      </ul>
      <h3>References</h3>
      <ul>
        <li>
          <a href="https://csrc.nist.gov/publications/detail/sp/800-53/rev-5/final">
            Special Publication 800-53 Rev. 5 (NIST)
          </a>
        </li>
      </ul>
    </Container>
  );
}

export default Home;
